<router-outlet class="antialiased"></router-outlet>

